import { createStore } from 'zustand/vanilla';

export type HeaderState = {
    overlayNotice: {
        open: boolean;
        btnLabel: string;
    };
    scrollY: number;
    scrollDirection: 'up' | 'down';
    hidden: boolean;
};

export type HeaderActions = {
    toggleOverlayNotice: () => void;
    setOverlayNotice: ({ btnLabel }: { btnLabel: string }) => void;
    setScrollY: (scrollY: number) => void;
};

export type HeaderStore = HeaderState & HeaderActions;

export const initHeaderStore = (): HeaderState => {
    return {
        overlayNotice: {
            open: false,
            btnLabel: '',
        },
        scrollY: 0,
        scrollDirection: 'up',
        hidden: false,
    };
};

export const defaultInitState: HeaderState = {
    overlayNotice: {
        open: false,
        btnLabel: '',
    },
    scrollY: 0,
    scrollDirection: 'up',
    hidden: false,
};

export const OVERLAY_STORAGE_ITEM_NAME = 'overlayNotice' as const;
export const OVERLAY_STORAGE_ITEM_VALUE = 'true' as const;

export const createHeaderStore = (initState: HeaderState = defaultInitState) => {
    return createStore<HeaderStore>()(set => ({
        ...initState,
        toggleOverlayNotice: () => {
            window.localStorage.setItem(OVERLAY_STORAGE_ITEM_NAME, OVERLAY_STORAGE_ITEM_VALUE);
            set(state => ({
                overlayNotice: {
                    ...state.overlayNotice,
                    open: !state.overlayNotice.open,
                },
            }));
        },
        setOverlayNotice: ({ btnLabel }: { btnLabel: string }) => {
            set(state => ({
                overlayNotice: {
                    ...state.overlayNotice,
                    btnLabel,
                },
            }));
        },
        setScrollY: (scrollY: number) =>
            set(state => {
                const scrollDirection = scrollY > 0 && scrollY > state.scrollY ? 'down' : 'up';
                return {
                    scrollY,
                    scrollDirection,
                    hidden: scrollDirection === 'down',
                };
            }),
    }));
};
